import React from 'react'
import { connect } from 'react-redux'
import { loadListBooking } from '../../../redux/actions/listBookingActions'
import ListBooking from './ListBooking'

const ListBookingContainer = ({
	listBookingResponse,
	listBookingError,
	getBookingDetails,
	retainFormData,
	gsaAgentDetails
}) => {
	return (
		<ListBooking
			listBookingResponse={listBookingResponse}
			listBookingError={listBookingError}
			getBookingDetails={getBookingDetails}
			retainFormData={retainFormData}
			gsaAgentDetails={gsaAgentDetails}
		/>
	)
}

const mapStateToProps = ({ listBooking,gsaAgent }) => ({
	listBookingResponse: listBooking.response,
	listBookingError: listBooking.error,
	gsaAgentDetails: gsaAgent
})

const mapDispatchToProps = (dispatch) => ({
	getBookingDetails: (bookingSearchFormData, pageNumber, defaultOrigin) => {
		const payload = { bookingSearchFormData, pageNumber, defaultOrigin }
		dispatch(loadListBooking(payload))
	},
})

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ListBookingContainer)
